const TermsOfService = () => {
  return (
    <>
      <div className="min-h-screen  py-12 px-6 md:px-10 ">
        <div className="max-w-7xl border  mx-auto  rounded-lg p-4 md:p-8 lg:p-8 mt-12 shadow-md">
          <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Terms Of Service
          </h1>
          <p className="text-gray-600 mb-4">
            These Terms of Service <b>(“Terms”)</b> shall constitute a legally
            binding agreement between DappLogix Software Pvt Ltd (
            <b>“Hirestar”</b> or <b>“we”</b> or
            <b> “us” </b> or <b>“our”</b>) having its registered place of
            business at JHUB, JNTU University campus, Kukatpally Hyderabad,
            Telangana, India 500085 and you, a user of the Services (
            <b>“user”</b> or <b>“you” </b> or <b>“your”</b>) with respect to
            your access and use of; (a) our Website -{" "}
            <b>https://hirtestar.io</b> and all associated web pages linked to
            the same owned by us, (b) our cloud based platform known by the
            proprietary brand name of <b>“Hirestar”</b> available at{" "}
            <a
              href="https://hirestar.io"
              className="text-blue-600 hover:underline"
            >
              https://hirestar.io
            </a>{" "}
            , that provides a comprehensive range of employee verification and
            screening services and employee onboarding and recruitment tracking
            services using its hyperledger blockchain technology and information
            obtained from third parties and the tools and services accessible
            via the platform (“Platform”), (c) the configuration and setup
            services offered by us and (d) our customer interface channels. All
            of which are hereinafter collectively referred to as the{" "}
            <b>“Services"</b>.
          </p>
          <p className="text-gray-600 mb-4">
            Please read these Terms carefully as they contain important
            information about your legal rights, remedies, and obligations. By
            accepting these Terms, either by signing up for an Account or
            accessing and using any of the Services or permitting any agent,
            entity or employee to access or use the Services, you agree to be
            bound by these Terms and our Privacy Policy{" "}
            <a
              href="
            https://hirestar.io/privacy-policy"
              className="text-blue-600 hover:underline"
            >
              https://hirestar.io/privacy-policy
            </a>
          </p>
          <p className="text-gray-600 mb-4">
            If you are signing up as a company, organization or any other legal
            entity <b>(“Entity”)</b>, you are agreeing to these Terms for that
            Entity and representing to Hirestar that you have the authority to
            enter into these Terms and bind such Entity and its affiliates to
            these Terms. If you do not agree to these Terms, then you may not
            access or use any of the Services. Any new features that augment or
            enhance the current Platform or Services, including the release of
            new tools and resources, shall be subject to these Terms.
          </p>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900   ">
              1. Permission to Access and Use the Services
            </h2>
            <div className="mt-2 rounded-lg text-gray-700 ">
              <p className="mb-4">
                1.1. In consideration for the payment of Fees, Hirestar shall
                provide to you the limited, non-exclusive, non-transferable,
                non-sublicensable, revocable right to use the Platform and
                Services for the purpose of undertaking employee background
                screening and verification services using our hyperledger
                blockchain technology and managing your employee recruitment and
                onboarding process. You will have access to browse, screen and
                track your employees and prospects and manage your own
                recruitment process and undertake background screening and
                verification services.
              </p>
              <p className="mb-4">
                1.2. You may access the Platform using only a single account.
                You agree not to request or allow another person(s) to create an
                account on your behalf, for your use, or for your benefit. When
                you sign up for an account on behalf of your entity you will
                automatically be assigned as the administrator. The
                administrator will have the right to configure the Platform and
                manage the account and all activities that are undertaken under
                the account. We shall not be responsible to manage or administer
                your account and/or provide any internal management services to
                you.
              </p>
              <p className="mb-4">
                1.3. You agree that the data that you provide us with shall
                always be accurate, correct and complete. You understand and
                acknowledge that we may periodically request for updates on such
                data.
              </p>
              <p className="mb-4">
                1.4. You are entirely responsible for any data, images or other
                materials (“User Data”) that is entered or uploaded from your
                account or otherwise provided to Hirestar pursuant to these
                Terms. You agree that you are the owner of or otherwise
                authorised by the owner of such User Data uploaded by you to the
                Platform or provided to Hirestar. You understand that we do not
                always monitor or control any User Data uploaded by you to the
                Platform. You agree not to use or encourage, permit others to
                store, upload, modify, update or share any information that
                violates these Terms of the Platform. Information you provide to
                us through the Services.
              </p>
              <p>
                1.5. We do not guarantee availability of the Platform at all
                times. We shall use reasonable efforts to make the Platform
                available to you, at all times. You understand and agree that
                the Platform is accessible over the Internet, data and cellular
                networks, the quality and availability of the same may be
                affected by factors outside our control. Therefore, we shall not
                be liable for non-availability of the Platform at any time. We
                may try to restore access to the Platform on a best reasonable
                and commercially viable basis.
              </p>
              <p>
                1.6. Both Parties, Hirestar and the user are independent
                contractors and nothing in these Terms is intended to, or shall
                be deemed to, establish any partnership, joint venture,
                employer-employee or agency between Hirestar and the user,
                appoint either party as the agent of the other, nor authorise
                either party to make or enter into any commitments for or on
                behalf of the other party. Hirestar’s obligations shall be
                limited only to the provision of the Services and do not in any
                way include acting on the user’s behalf.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              2. Registration of Account
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                2.1. To be eligible to access and use our Services, you are
                required to create an account on the Platform by completing the
                registration process and entering in account information as
                requested. While registering for an account you must enter a
                genuine and official email id, cell phone number and other
                details requested. You warrant that the details entered by you
                are true and valid.
              </p>
              <p className="mb-4">
                2.2. Hirestar may conduct a brief verification of the details
                entered by you to confirm their validity. In case Hirestar
                suspects that any details entered by you are not genuine, or you
                have created a false account, Hirestar shall suspend and/or
                delete your account, along with any User Data in that account,
                without refunds, if any.
              </p>
              <p className="mb-4">
                2.3. You are responsible for keeping all account Information
                current and complete. You are also responsible for all the
                activity that occurs through or within the account. Any abusive,
                fraudulent or unauthorized use of the Platform shall warrant
                termination of its right to access and use the Platform. You are
                fully liable for any fraudulent, abusive or illegal activity or
                data storage that occurs through the account. You shall keep
                your login details (username and password) confidential. You
                shall inform us immediately should you suspect the theft of your
                login details or any suspicious activity through your account.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              3. Permissible Uses of the Services and User Obligations
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                3.1. You agree that you are responsible for your own conduct
                (including that of your administrators authorised by you) while
                using the Platform and Services and for any consequences
                thereof. You agree to use the Platform only for purposes that
                are legal, proper and in accordance with these Terms and any
                applicable policies and guidelines.
              </p>
              <p className="mb-4">
                3.2. You agree that you shall access or use the Services for
                your internal business purposes only and not for any commercial
                gain. We have no liability to you for any loss of profit, loss
                of business, or loss of business opportunity in any case
                whatsoever.
              </p>
              <p className="mb-4">
                3.3. The Services allow you to upload and/or enter personal data
                of persons that are not registered on the Platform, you agree
                and warrant that you have obtained lawful and legitimate consent
                from such persons before uploading and/or entering their
                personal data on the Platform. You understand and agree that
                Hirestar shall not be responsible for obtaining any consent
                and/or permissions from any person prior to processing their
                personal data handed over to it by you.
              </p>
              <p className="mb-4">
                3.4. While using the Services, you shall not, and not permit
                anyone to attempt to or otherwise do any of the following;
              </p>
              <ul className="space-y-2 mb-4">
                <li>
                  a. Transfer your account to another party without our consent;
                </li>
                <li>
                  b. Interfere with any other user’s right to use the Services;
                </li>
                <li>c. post/upload any incorrect candidate data;</li>
                <li>
                  d. Upload any code and/or content that is illegal or may
                  infringe upon the intellectual property rights of any third
                  party;
                </li>
                <li>
                  e. Infringe any laws applicable to you, third-party rights,
                  especially intellectual property rights or our policies;
                </li>
                <li>
                  f. post content or items in inappropriate areas on our
                  Platform and Services;
                </li>
                <li>
                  g. defame, abuse, harass, stalk, threaten or otherwise violate
                  the legal rights (such as rights of privacy and publicity) of
                  others; upload, post, email or transmit or otherwise make
                  available any inappropriate, defamatory, infringing, obscene,
                  or unlawful content;
                </li>
                <li>
                  h. Use the Platform or Services to blackmail any other person
                  or for otherwise inappropriate purposes or to improperly
                  access or view or distribute obscene, pornographic, or
                  otherwise sexually explicit material;
                </li>
                <li>
                  i. post or transmit, or cause to be posted or transmitted, any
                  communication or solicitation designed or intended to obtain
                  password and Account Information from any other users of the
                  Platform;
                </li>
                <li>
                  j. remove any copyright, trademark or other proprietary rights
                  notices contained in or on the Platform and the Services;
                </li>
                <li>
                  k. Rent, lease, lend, sell, sublicense, assign, distribute,
                  publish, transfer or otherwise make available the Services or
                  any features or functionality of the Services, to any third
                  party for any reason;
                </li>
                <li>
                  l. distribute or post spam, unsolicited, or bulk electronic
                  communications, chain letters, or pyramid schemes;
                </li>
                <li>
                  m. misuse our Services by knowingly introducing viruses,
                  trojans, worms, logic bombs or other material which is
                  malicious or technologically harmful;
                </li>
                <li>
                  n. You must not attempt to gain unauthorised access to our
                  website, the server on which our website is stored or any
                  server, computer or database connected to our website;
                </li>
                <li>
                  o. attempt to modify, translate, adapt, edit, decompile,
                  disassemble, or reverse engineer any software used by us in
                  connection with the Platform;
                </li>
                <li>
                  p. distribute any file posted by another that you know, or
                  reasonably should know, cannot be legally distributed in such
                  manner;
                </li>
                <li>
                  q. impersonate another person or entity, or falsify or delete
                  any author attributions, legal or other proper notices or
                  proprietary designations or labels of the origin or source of
                  software or other material;
                </li>
                <li>
                  r. use the Platform to facilitate money exchange including,
                  but not limited to, cryptocurrency;
                </li>
                <li>
                  s. violate any applicable law, statute, ordinance or
                  regulation, or encourage any conduct that could constitute a
                  criminal offense or give rise to civil liability.
                </li>
              </ul>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900 rounded-lg">
              4. Fees and Payment Terms
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                4.1. In consideration of the Services provided by Hirestar, you
                shall pay to us fees as communicated by us to you from time to
                time. Hirestar will invoice you for all fees and you agree to
                pay all invoiced amounts in a manner as agreed between you and
                Hirestar.
              </p>
              <p className="mb-4">
                4.2. All fees paid by you to Hirestar are non-refundable. You
                acknowledge and agree that no refunds shall be paid on account
                of opting out, cancellation, non-use or partial use of the
                Services.
              </p>
              <p className="mb-4">
                4.3. All fees shall be exclusive of GST and other taxes. You are
                responsible for paying all the applicable taxes. Hirestar shall,
                if it has the legal obligation to do so, include such amounts in
                the invoice.
              </p>
              <p className="mb-4">
                4.4. In case of non-payment for any reason or any violation of
                these Terms by you and/or you administrators, we reserve the
                right to without any liability to you, immediately suspend
                and/or terminate your access to the Services.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              5. Feedback
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                If you provide us with suggestions, ideas, improvements,
                recommendations or other feedback with respect to any aspect of
                the Services (“<b>Feedback”</b>), we may use and/or exploit this
                Feedback. We will have no confidentiality obligations with
                respect to the Feedback. You agree that we will be free to copy,
                modify, create derivative works, publicly display, disclose,
                distribute, license and sublicense, incorporate and otherwise
                use the Feedback, including derivative works thereto, for any
                and all purposes.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              6. Demo Services
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                Users may request for a demo use of the Services provided on the
                Platform. The Services provided are AS IS, with no warranty
                during this period. For requesting a demo use of the Services
                provided on the Platform, the User is required to provide
                certain personal information including the user’s name, a valid
                official email address, phone number etc. The use of such
                personal information is governed by our Privacy Policy which is
                incorporated into these Terms by reference.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              7. Intellectual Property Rights
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                7.1. All Intellectual Property rights relating to Hirestar,
                Platform & website, its content, software code, materials
                including, but not limited to text, data, information, graphics,
                logos, tools, photographs, images, illustrations, audio, video
                and animations are Intellectual Property owned by or licensed to
                Hirestar and/or third parties and are protected by the laws of
                India and international copyright laws. All trademarks, service
                marks, and trade names are proprietary to Hirestar and/or third
                parties. You acknowledge and agree that all Intellectual
                Property rights in the Platform and website vest with Hirestar
                and Hirestar retains all ownership, rights, title and interest
                in the Platform and the website and that nothing in these Terms
                gives you any right, title or interest in or to the Platform or
                website or any of Hirestar’s Intellectual Property.
              </p>
              <p className="mb-4">
                7.1. “<b>Intellectual Property</b>” shall mean all existing and
                future copyrights, patents, any extensions of the exclusivity
                granted in connection with patents, patents pending, utility
                models, registered designs, trademarks, service marks,
                applications for any of the foregoing (including continuations,
                continuations-in-part and divisional applications), the right to
                apply for any of the foregoing, rights in trade names, business
                names, brand names, get-up, logos, domain names and URLs, design
                rights, moral rights, database rights, publication rights, all
                rights in and to the intellectual property, having equivalent or
                similar effect to any of the foregoing rights, which may exist
                anywhere in the world.
              </p>
              <p className="mb-4">
                7.3. You shall not copy, modify, publish, transmit, upload,
                participate in the transfer or sale of, reproduce, create
                derivative works based on, distribute, or in any way
                commercially exploit any of the Platform content, software,
                materials relating to the Platform in whole or in part. You
                agree to abide by all copyright notices, information, and
                restrictions contained in any content accessed through the
                Platform.
              </p>
              <p className="mb-4">
                7.4. You shall own and retain all right, title and interest with
                respect to all User Data. All the rights of Intellectual
                Property, including but not limited to the information obtained
                through online forms, which contain additional information such
                as personal information and business information etc. are and
                will remain your property. You hereby expressly grant to
                Hirestar an exclusive, royalty free, worldwide, transferable,
                irrevocable, sub-licensable and perpetual license and right to
                use, copy, modify, distribute, publish, and process, User Data
                for the purpose of providing the Services.
              </p>
              <p className="mb-4">
                7.5. Notwithstanding anything to the contrary contained herein,
                we shall have a right to use your name and trademark/logo in our
                marketing materials, including but not limited to the website,
                emails, pamphlets solely for the purposes of communicating that
                the Services have been provided to you.
              </p>
              <p>
                7.6. User agrees to only provide content or information that
                does not violate the law, any agreement in force, nor anyone's
                rights, including a person’s right to privacy. Hirestar reserves
                the right to suspend or terminate its account with us, if there
                is any fraud or misrepresentation found in the user content and
                information which the user provided to us.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              8. Confidentiality and Security
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                8.1. “<b>Confidential Information</b>” shall mean and include
                these Terms and any and/or all business information, data
                relating to processes and procedures, advertising and marketing
                plans or marketing information, data and/or material, any
                technical, marketing, financial and commercial information, all
                customer related information including any rates and discounts
                and also includes any other information disclosed by one party
                to the other which is (a) conspicuously marked “confidential” or
                “proprietary” if in tangible form, (b) identified as
                “confidential” or “proprietary” at the time of disclosure or (c)
                any other information that, when taking into consideration the
                circumstances surrounding disclosure of the same, a reasonable
                person would determine to be of a confidential or proprietary
                nature.
              </p>
              <p className="mb-4">
                8.2. You understand and agree that certain information that may
                be disclosed can be available to the public on blockchain.
                Should any such information be confidential in nature, it must
                be disclosed specifically to us in order to enable it to keep
                such information out of the blockchain database.
              </p>
              <p className="mb-4">
                8.3. Subject to the above, each party agrees to hold and treat
                all Confidential Information of the other party, as confidential
                and use all reasonable efforts to maintain the confidentiality
                of all the Confidential Information of the other party that is
                in its possession or control or that it may have access to, in
                connection with these Terms, but in no event less than the
                efforts that it ordinarily uses with respect to its own
                Confidential Information.
              </p>
              <p className="mb-4">
                8.4. Confidential Information shall not include any information
                that; (a) parties have agreed to share on blockchain database;
                (b) at the time of the disclosure is lawfully obtained from
                publicly available sources generally known by the public (other
                than as a result of a disclosure by the receiving Party or its
                representatives); (c) is available to the receiving Party on a
                non-confidential basis from a source that is not and was not
                bound by a confidentiality agreement with respect to the
                Confidential Information; or (d) has been independently acquired
                or developed by the receiving Party without violating its
                obligations under these Terms or under any applicable law.
              </p>
              <p className="mb-4">
                8.5. The receiving party shall restrict access to Confidential
                Information only to its employees and consultants who require
                such access in the course of their assigned duties and
                responsibilities and who have been informed of the receiving
                party’s obligations of confidentiality.
              </p>
              <p className="mb-4">
                8.6. Either party shall not disclose Confidential Information
                belonging to the other party, to any third parties, without the
                express written permission of the other Party, except for the
                purpose of these Terms.
              </p>
              <p className="mb-4">
                8.7. The receiving Party may disclose the disclosing Party’s
                Confidential Information if required to do so by an order of
                court or government agency, provided, however, that the
                receiving Party shall only disclose such information to the
                extent required by such court or government agency and will make
                commercially reasonable efforts to notify the disclosing Party
                prior to making such disclosure.
              </p>
              <p className="mb-4">
                8.8. You grant your consent to us to disclose to our affiliates
                / partners / third parties the Account Information to the extent
                necessary for the purpose of performing our obligations under
                this Terms
              </p>
              <p className="mb-4">
                8.9. The receiving party may disclose the disclosing party’s
                Confidential Information if required to do so by an order of
                court or government agency, provided, however, that the
                receiving party shall only disclose such information to the
                extent required by such court or government agency and will make
                commercially reasonable efforts to notify the disclosing party
                prior to making such disclosure.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900 rounded-lg">
              9. Data Privacy
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                The treatment of all Personal Data shall be governed by Hirestar
                Privacy Policy, located at{" "}
                <a
                  href="https://hirestar.io/privacy-policy"
                  className="text-blue-600 hover:underline"
                >
                  https://hirestar.io/privacy-policy
                </a>{" "}
                which is incorporated into these Terms by reference.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900 ">
              10. Term and Termination
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                10.1. These Terms shall remain in effect from the date of
                completion of registration of the account until termination by
                cancellation or suspension of the account by either user or
                Hirestar.
              </p>
              <p className="mb-4">
                10.2. You may terminate your registration or delete your Account
                by sending an email to our support team, if you no longer wish
                to use the Platform. Upon termination, you will cease to have
                access to the Platform or any of the Services.
              </p>
              <p className="mb-4">
                10.3. Hirestar retains the right to terminate or suspend or
                permanently disable the user’s access to or use of the Service,
                at any time without any prior notice, if Hirestar determines
                that the user has repeatedly violated these Terms or other
                policies of Hirestar.
              </p>
              <p>
                10.4. Any amounts owed by you prior to termination remain owed
                after termination.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              11. Enforcement by Hirestar
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                Hirestar reserve the right to investigate and take appropriate
                action in our sole discretion against the User if you violate
                these Terms, including without limitation: suspending your
                rights to use the Services; reporting you to law enforcement,
                regulatory authorities, or administrative bodies; and taking
                legal action against you.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              12. Third Party Services
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                In order to give you better services, we may partner with third
                party vendors to provide certain services. Hirestar cannot and
                does not take any responsibility and does not make any warranty
                on behalf of such third party services.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              13. Disclaimer of Warranties
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                13.1. Except as provided in these Terms, the Services and all
                information provided through the Platform are ‘<b>AS IS</b>' and
                ‘<b>AS AVAILABLE</b>’. Other than those expressly provided in
                these Terms, Hirestar makes no other warranties,
                representations, conditions or guarantees, express or implied,
                and hereby, to the maximum extent permitted by law, disclaims
                all warranties, including any warranty, representation,
                conditions, or guarantees of quality, merchantability, fitness
                for a particular purpose or non-infringement.
              </p>
              <p className="mb-4">
                13.2. The background check report of a candidate obtained by
                Hirestar is obtained using blockchain technology and derived
                from databases and records that have been created and maintained
                by various government agencies, educational institutions,
                private companies, and other contributors that are not under the
                control of Hirestar. Responsibility for the accuracy of the
                information contained in the background check report and these
                databases and records rests solely in the contributor. The user
                waives any and all claims against Hirestar arising out of or
                related to the accuracy of the applicant report, databases and
                records.
              </p>
              <p className="mb-4">
                13.3. Hirestar does not warrant that; (a) the Services will be
                uninterrupted, secure, timely, or error free; (b) the Platform
                will meet your requirements; (c) that the information provided
                through the Platform, website and Services is accurate, reliable
                or correct; (d) that any defects or errors will be corrected;
                (e) that the Platform and website will be available at any
                particular time or location; or (f) that the Platform or website
                is free of viruses malicious softwares or other harmful
                components.
              </p>
              <p className="mb-4">
                13.4. Hirestar shall not be responsible for any harm caused to
                the User’s computer system, loss or corruption of data or other
                such harm that results from the access of use of Services.
              </p>
              <p className="mb-4">
                13.5. No advice or information, whether oral or written,
                obtained by you from the Platform or otherwise from us shall
                create any warranty not expressly stated in these Terms.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              14. Indemnification
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                14.1. You agree to indemnify, keep indemnified, defend and hold
                harmless Hirestar and its directors, officers, employees,
                assigns and agents from and against any and all losses,
                expenses, claims, costs and damages suffered, directly or
                indirectly, arising out of, or which may arise in connection
                with (i) any misrepresentation or any breach of any
                representation or warranty contained in these Terms; (ii) any
                breach of or non-compliance with any covenant or any other term
                of these Terms by you; (iii) your use of the Services and/or the
                Platform, (iv) your negligence and wilful misconduct or (v) any
                violation by you of any applicable laws, rules or regulations.
              </p>
              <p className="mb-4">
                14.2. You shall, at your sole expense and cost, indemnify,
                defend and hold harmless Hirestar and its respective officers,
                directors and personnel, from and against, any and all
                liabilities suffered or incurred (including, but not limited to,
                judgments losses, claims, costs and expenses, including
                reasonable attorney’s fees and expenses) or any other loss that
                may be incurred including those arising out of a third party
                claim due to; (a) your use or misuse of the Services or Platform
                or website, or (b) as a result of any threatening, libelous,
                obscene, harassing or offensive material posted/ transmitted by
                you through the Platform and/or website or (c) any claim brought
                or made by a candidate against Hirestar; or (d) any background
                check process as performed for you.
              </p>
              <p className="mb-4">
                14.3. you recognize that information contained in the reports
                provided to you is obtained through blockchain technology and
                from various third party sources and Hirestar cannot ensure or
                guarantee the accuracy of the information obtained. You hereby
                expressly release and hold harmless Hirestar and its affiliates,
                officers, agents, employees, and contractors from any liability
                for claims arising out of inaccurate or incomplete information
                reported.
              </p>
              <p className="mb-4">
                14.4. Hirestar shall indemnify, defend and hold the user
                harmless against any third party claim alleging that the use of
                the Services infringes upon such third party’s intellectual
                property rights, provided that Hirestar is provided with a
                prompt written notice of such claims and reasonable assistance
                and sole control over the defense and settlement of the claim by
                the user.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              15. Limitation of Liability
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                15.1. In no event shall either party be liable to the other
                party for any incidental, indirect, remote special,
                consequential or punitive damages, loss of goodwill or business
                profits, regardless of the nature of the claim, even if such
                party knew or should have known of the possibility of such
                damages or claims.
              </p>
              <p className="mb-4">
                15.2. You understand and agree that, to the extent permitted by
                applicable laws, ‍Hirestar and its directors, officers,
                employees, agents shall not be liable for any indirect,
                incidental, special consequential, punitive or exemplary damages
                arising out of or in connection with;
                <ul className="mt-4 space-y-1">
                  <li>
                    a. The use or the inability to use the Services for any
                    reason;
                  </li>
                  <li>
                    b. The cost of procurement of substitute goods and/or
                    services resulting from any goods, data, information or
                    services purchased or relied on, messages received or
                    transactions entered into through the Platform or Services;
                  </li>
                  <li>
                    c. Statements or conduct of any third party on the Services;
                  </li>
                  <li>
                    d. any security breach or any virus, bug, unauthorized
                    intervention, defect, or technical malfunctioning of the
                    Platform and/or Services; or
                  </li>
                  <li>
                    e. the use, disclosure, or display of your account
                    information;
                  </li>
                  <li>
                    f. reliance by you on information featuring on the Services
                    that is obtained from public sources or third parties;
                  </li>
                </ul>
              </p>
              <p className="mb-4">
                15.3. No action against either party arising out of these Terms
                may be brought by the other party more than twelve (12) months
                after the cause of action has arisen.
              </p>
              <p className="mb-4">
                15.4. We shall have no liability to you for any breach of these
                Terms caused by any events of force majeure or circumstance
                beyond our reasonable control including, without limitation,
                strikes, lock-outs or other industrial disputes, breakdown of
                systems or network access, or flood, fire, explosion or
                accident. We disclaim all liability to you for any legal damage
                caused due to acts or omissions of a third party or your breach.
              </p>
              <p className="mb-4">
                15.5. Notwithstanding the above, in any case, Hirestar’s maximum
                liability shall be equivalent to and in no event shall
                Hirestar’s liability exceed{" "}
                <b>INR 50,000/- (Indian Rupees Fifty Thousand only).</b>
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              16. Jurisdictional Issues
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                Hirestar makes no representation that the Services operate (or
                is legally permitted to operate) in all geographic areas, or
                that the Services are appropriate or available for use in other
                locations. Accessing the Services from territories where the
                Services or any content or functionality of the Services or
                portion thereof is illegal is expressly prohibited. If you
                choose to access the Services, you agree and acknowledge that
                you do so on your own initiative and at your own risk, and that
                you are solely responsible for compliance with all applicable
                laws.
              </p>
            </div>
          </div>
          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              17. Governing Law and Jurisdiction
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                These Terms shall be governed and construed in accordance with
                the laws of India. The parties irrevocably submit to the
                exclusive jurisdiction of the courts in Hyderabad, Telangana any
                disputes or claims arising out of or relating to these Terms.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              18. Miscellaneous Terms
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                18.1. <b>Severability:</b> If any of the provisions of these
                Terms are deemed invalid, void, or for any reason unenforceable,
                that part of the Terms will be deemed severable and will not
                affect the validity and enforceability of any remaining
                provisions of these Terms.
              </p>
              <p className="mb-4">
                18.2. <b>Waiver:</b> Any failure on our part to require
                performance of any provision of these Terms shall not affect our
                right to full performance thereof at any time thereafter, and
                any waiver by us of a breach of any provision hereof shall not
                constitute a waiver of a similar breach in the future or of any
                other breach. By agreeing to these Terms, you understand that
                you are entering into a commercial transaction and agree to
                waive any rights under any usury and other laws relating to
                charging of interest.
              </p>
              <p className="mb-4">
                18.3. <b>Assignment:</b> Hirestar may assign any of its rights
                and obligations under these Terms without any notification to or
                the prior consent of the User. However, the User shall not
                assign or transfer these Terms without the prior written consent
                of Hirestar.
              </p>
              <p className="mb-4">
                18.4. <b>Entire Agreement:</b> Unless otherwise as expressly
                agreed upon in writing between Hirestar and the User, these
                Terms shall constitute the entire agreement between Hirestar and
                the User and shall supersede any prior understandings,
                proposals, negotiations, and agreements in relation to the
                subject matter of these Terms, whether written or oral. As noted
                earlier in these Terms, other policies and guidelines which
                govern the User’s access to or use of the Services are
                incorporated herein by reference.
              </p>
              <p className="mb-4">
                18.5. <b>Modifications:</b> We reserve the right to make changes
                to the functionality of the Platform from time to time, without
                affecting any rights that are accrued to you. We shall perform
                all necessary server management and maintenance services with
                respect to the Platform. Subject to the conditions set forth
                herein, Hirestar, at its sole discretion, may amend, modify,
                replace or supplement the Terms at any time by posting a revised
                version on the Platform. We may change these Terms without
                sending a prior notice of the same. Any changes to these Terms
                shall come into effect on posting the updated version on our
                Platform. You are requested to check our Platform periodically
                for such updates. The continued use of the Services by the User
                after a notice of change has been published on our Platform
                shall mean that the User has accepted such changes.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              19. Communications and Notices
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                You agree to receive electronically all communications,
                agreements, documents, notices, and disclosures that we provide
                in connection with the Platform. We may connect and communicate
                with you in a variety of ways, including by e-mail, text,
                in-Platform notifications, or by posting them through the
                Platform. You agree that all such communications that we provide
                to you electronically satisfy any legal requirement that such
                communications be in writing. Notices to us shall be addressed
                as follows:
              </p>
              <ul className="mt-3 text-gray-600 space-y-1">
                <li>
                  <span className="font-semibold">
                    DappLogix Software Private Limited{" "}
                  </span>
                </li>
                <li>
                  <span className="font-semibold">
                    Thub, 20, Inorbit Mall Rd, Vittal Rao Nagar,{" "}
                  </span>
                </li>
                <li>
                  <span className="font-semibold">Madhapur, Hyderabad, </span>
                </li>
                <li>
                  <span className="font-semibold">Telangana 500081 </span>
                </li>
                <li>
                  <span className="font-semibold">Email: </span>
                  <a
                    href="mailto:admin@hirestar.io"
                    className="text-blue-600 hover:underline"
                  >
                    admin@hirestar.io
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900 rounded-lg">
              14. Contact Us
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                If you have questions regarding these Terms and/or want to
                report any violations of these Terms, please feel free to reach
                out to us on:{" "}
                <a
                  href="mailto:admin@hirestar.io"
                  className="text-blue-600 hover:underline"
                >
                  admin@hirestar.io
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;
